module.exports = __webpack_public_path__ + "static/media/thumbnail-csarnok-y-szektor-kft.643c1502.jpg";